// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge-module--badge--yF7Gn","icon":"Badge-module--icon--3Ohjc"};